import React from 'react'
import { POSITION_PROPS } from './interface'
import { Position, PositionsContainer, Content } from './PositionStyles'

function PositionHolder({ title, content, icon, withBet }: POSITION_PROPS) {
  return (
    <PositionsContainer active={title === 'ANTE'} withBet={withBet}>
      <Position active={title === 'ANTE'} withBet={withBet}>
        <Content
          active={title === 'ANTE'}
          withBet={withBet}
          turn={title === 'TURN'}
        >
          {content > '0' ? content : icon}
        </Content>
      </Position>
      <span>{title}</span>
    </PositionsContainer>
  )
}

export default PositionHolder
